import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isPage: false,
        page: '/',
        runAnimation: true,
        // api: 'https://admin.joyfully-waiting.ch/wp-json/api/v1',
        api: 'https://joyfully-waiting.ch/wp/wp-json/api/v1',
        color: 1,
        currentArtwork: null,
        currentArtworkTimestamp: null,
        soundFrequency: 0,
        menuStatus: false,
        echoesContributions: null,
    },
    actions: {
        async getEchoesContributions({ commit, state }) {
            if (state.echoesContributions) {
                return;
            }
            const { data } = await axios.get(`${state.api}/get_contributions`, {
                params: { id: 'about' },
            })
            commit('setEchoesContributions', data);
        }
    },
    mutations: {
        setIsPage(state, val) {
            state.isPage = val;
        },
        setPage(state, val) {
            state.page = val;
        },
        setRunAnimation(state, val) {
            state.runAnimation = val;
        },
        setColor(state, val) {
            state.color = val;
        },
        setCurrentArtwork(state, val) {
            state.currentArtwork = val;
        },
        setCurrentArtworkTimestamp(state, val) {
            state.currentArtworkTimestamp = val;
        },
        setSoundFrequency(state, val) {
            state.soundFrequency = val;
        },
        setMenuStatus(state, val) {
            state.menuStatus = val;
        },
        setEchoesContributions(state, val) {
            state.echoesContributions = val;
        }
    }

})

export default store;